import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { forgotPassword, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      setSent((await forgotPassword(email)).message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter your email and we'll send you a link to choose a new one.">
      {sent ? (
        <div data-testid="forgot-success" className="flex gap-3 p-4 rounded-xl border border-[#D4FF3A]/25 bg-[#D4FF3A]/5 text-sm text-slate-300">
          <MailCheck size={18} className="text-[#D4FF3A] shrink-0 mt-0.5" /> {sent}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="what-input" />
          {error && <p data-testid="forgot-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="forgot-submit-btn" disabled={busy} className="what-btn-primary w-full !py-3">
            {busy && <Loader2 size={16} className="animate-spin" />} Send reset link
          </button>
          <p className="text-xs text-slate-500">Student? Ask your teacher to reset your password.</p>
        </form>
      )}
    </AuthShell>
  );
}
